/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-15 10:25:42
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-15 12:02:40
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/SalesChannelCollapseWrapper/index.tsx
 */
import { Collapse } from '@/src/components/Antd';
import React from 'react';
import GeneralCollapseContent from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseContent';
import GeneralCollapseHeader from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseHeader';
import GeneralCollapseWrapper from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseWrapper';

const headerPropsProcessor = (headerProps, isPrimary) => {
  const _headerProps = { ...(headerProps || {}) };
  if (_headerProps.hideDotsWhenNotPrimary && !isPrimary) {
    _headerProps.hasDots = false;
  }
  return _headerProps;
};

const CollapseWrapper = (props) => {
  const {
    children,
    id,
    open,
    title,
    displayError,
    headerProps,
    isPrimary,
    generalError,
    onCollapseOpen,
    bordered,
    expandOffset = 12,
    collapseProps,
    withoutCollapse,
  } = props;
  const renderTitle = () => {
    return (
      <GeneralCollapseHeader
        content={title}
        err={displayError}
        {...(headerPropsProcessor(headerProps, isPrimary) || {})}
      />
    );
  };
  return (
    <GeneralCollapseWrapper>
      <Collapse
        id={id}
        err={null}
        open={open}
        title={renderTitle()}
        bordered={bordered}
        content={
          <GeneralCollapseContent err={generalError}>
            {children}
          </GeneralCollapseContent>
        }
        clickToExpand
        withoutCollapse={withoutCollapse}
        expandOffset={expandOffset}
        onClickTrigger={onCollapseOpen}
        {...(collapseProps || {})}
      />
    </GeneralCollapseWrapper>
  );
};
export default CollapseWrapper;
